<!--
 * @Date: 2022-09-28 17:36:33
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-10 15:55:27
 * @description: description
-->
<template>
  <div :class="$style.developmentHistory">
    <div :class="$style.historyTitle">
      {{ info.title }}
    </div>
    <div :class="$style.historyImgBox">
      <img :src="info.coverMobile" alt="" />
    </div>
  </div>
</template>
<script>

export default {
  name: 'aboutus-development-history',
  props: {
    info: Object
  }
}
</script>

<style lang="scss" module>
.developmentHistory {
  position: relative;
  box-sizing: border-box;
  padding-top: 30px;

  .historyTitle {
    height: 28px;
    margin-bottom: 29px;
    text-align: center;
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #404040;
  }

  .historyImgBox {
    width: 351px;
    height: 875px;
    margin: 0 auto 50px;

    & > img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
